import { actionNames } from './actions.playback'

const initialState = {
  liveId: null,
  playbackState: null,
  stagedPlaybackVideos: [],
  selectedPlaybackPhotoId: null,
  pendingPlaybackPhotoId: null,
  isPlaybackSelectorOpen: false,
  isFetchingPlaybackVideos: false,
  videosFetched: false,
  playingVideoIsPaused: false,
  isVideoPlaying: false,
  currentPlayPosition: 0,
  videoDuration: null,
  loopingPhotoIds: new Set(),
}

export default (state = initialState, action = undefined) => {
  switch (action.type) {
    case actionNames.LOAD_PLAYBACK_VIDEOS: {
      return {
        ...state,
        liveId: action.liveId,
        isFetchingPlaybackVideos: !state.videosFetched,
      }
    }
    case actionNames.STAGE_PLAYBACK_VIDEOS_SUCCESS: {
      return {
        ...state,
        stagedPlaybackVideos: action.videos || [],
        isFetchingPlaybackVideos: false,
        videosFetched: true,
      }
    }
    case actionNames.UNSTAGE_PLAYBACK_VIDEO: {
      return {
        ...state,
        stagedPlaybackVideos: state.stagedPlaybackVideos.filter(
          (video) => video.photo_id !== action.video.photo_id
        ),
      }
    }
    case actionNames.VIDEO_SELECTED_FOR_PLAYBACK: {
      const photoId = action.video.photo_id || action.video.key

      return {
        ...state,
        playbackState: 'play_intent_sent',
        playingVideoIsPaused: false,
        selectedPlaybackPhotoId: photoId,
        pendingPlaybackPhotoId: photoId,
      }
    }
    case actionNames.HEADLESS_PLAYBACK_READY: {
      return {
        ...state,
        playbackState: 'headless_play_ready',
      }
    }
    case actionNames.VIDEO_PLAYBACK_STARTED: {
      return {
        ...state,
        isVideoPlaying: true,
        playbackState: 'playing',
        pendingPlaybackPhotoId: null,
        playingVideoIsPaused: false,
        selectedPlaybackPhotoId: action.selectedPlaybackPhotoId,
      }
    }
    case actionNames.VIDEO_PLAYBACK_METRICS_UPDATED: {
      return {
        ...state,
        currentPlayPosition: action.metrics.position,
        videoDuration: action.metrics.duration,
      }
    }
    case actionNames.VIDEO_PLAYBACK_FAILED: {
      return {
        ...state,
        pendingPlaybackPhotoId: null,
      }
    }
    case actionNames.VIDEO_PLAYBACK_STOPPED: {
      return {
        ...state,
        playbackState: null,
        isVideoPlaying: false,
        playingVideoIsPaused: true,
      }
    }
    case actionNames.VIDEO_INFO_FETCH_SUCCESS: {
      return {
        ...state,
        stagedVideosInfo: {
          ...state.stagedVideosInfo,
          [action.video.photo_id]: action.video,
        },
      }
    }
    case actionNames.OPEN_PLAYBACK_SELECTOR: {
      return {
        ...state,
        isPlaybackSelectorOpen: true,
      }
    }
    case actionNames.PLAYBACK_SELECTOR_CLOSED: {
      return {
        ...state,
        isPlaybackSelectorOpen: false,
      }
    }
    case actionNames.PAUSE_VIDEO: {
      return {
        ...state,
        playingVideoIsPaused: true,
      }
    }
    case actionNames.UNPAUSE_VIDEO: {
      return {
        ...state,
        playingVideoIsPaused: false,
      }
    }
    case actionNames.UPDATE_PAUSED_STATE: {
      return {
        ...state,
        playingVideoIsPaused: true,
      }
    }
    case actionNames.ENABLE_LOOPING: {
      const newSet = new Set([...state.loopingPhotoIds])

      newSet.add(state.selectedPlaybackPhotoId)

      return {
        ...state,
        loopingPhotoIds: newSet,
      }
    }
    case actionNames.DISABLE_LOOPING: {
      const newSet = new Set([...state.loopingPhotoIds])

      newSet.delete(state.selectedPlaybackPhotoId)

      return {
        ...state,
        loopingPhotoIds: newSet,
      }
    }
    case actionNames.VIDEO_ENDED: {
      return {
        ...state,
        playbackState: 'ended',
        isVideoPlaying: true, // in case we need to recover from this state
        selectedPlaybackPhotoId: action.selectedPlaybackPhotoId,
      }
    }
    default:
      return state
  }
}
